import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faCirclePlus,
  faCircleMinus,
} from "@fortawesome/free-solid-svg-icons";
import { documentService } from "../../../service";
import { toast } from "react-toastify";
import "../NewResponse/NewResponse.css";

const EditResponseOffcanvas = ({ show, onClose, form, documentData, onUpdated  }) => {
  const [responseData, setResponseData] = useState({});
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (show && documentData) {
      setResponseData(documentData.values_json || {});
    }
  }, [show, documentData]);

  if (!show || !form) return null;

  const handleChange = (label, value, fieldType) => {
    let parsedValue = value;

    if (fieldType === "integer") parsedValue = value ? parseInt(value, 10) : null;
    else if (fieldType === "float") parsedValue = value ? parseFloat(value) : null;
    else if (fieldType === "boolean") parsedValue = value === "true";
    else if (fieldType === "checkbox" && !Array.isArray(value)) parsedValue = [];

    setResponseData(prev => ({ ...prev, [label]: parsedValue }));
  };

  const toggleCheckboxOption = (label, option) => {
    setResponseData(prev => {
      const prevOptions = prev[label] || [];
      return prevOptions.includes(option)
        ? { ...prev, [label]: prevOptions.filter(opt => opt !== option) }
        : { ...prev, [label]: [...prevOptions, option] };
    });
  };

  const validateForm = () => {
    const newErrors = {};

    form.fields?.forEach(field => {
      const value = responseData[field.label];

      if (field.field_type === "section-title") return;

      if (
        field.required &&
        (value === undefined ||
          value === null ||
          value === "" ||
          (Array.isArray(value) && value.length === 0))
      ) {
        newErrors[field.label] = "Ce champ est obligatoire.";
        return;
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (!validateForm()) {
      toast.error("Veuillez corriger les erreurs.");
      return;
    }

    try {
      const payload = {
        values_json: responseData,
        form_id: form.id,
      };

      await documentService.update(documentData.id, payload);

      toast.success("Réponse modifiée avec succès !");
      if (onUpdated) onUpdated();  
      onClose();
    } catch (error) {
      console.error("Erreur lors de la mise à jour :", error);
      toast.error("Erreur lors de la modification.");
    }
  };

  return (
    <div
      className="offcanvas-backdrop-custom"
      style={{ display: show ? "block" : "none" }}
    >
      <div
        className={`offcanvas offcanvas-end ${show ? "show" : ""}`}
        tabIndex="-1"
        style={{ visibility: show ? "visible" : "hidden" }}
      >
        <div className="border-bottom d-flex justify-content-start align-items-center p-2">
          <button type="button" className="btn-close me-2" onClick={onClose}></button>
          <h5 className="NewEntryoffcanvas-title">
            Modifier la réponse : {form.title}
          </h5>
        </div>

        <div className="offcanvas-body">
          <form onSubmit={handleSubmit}>
            {form.fields?.map(field => (
              <div
                key={field.id}
                className="doc-attr py-1 px-4 d-flex flex-column justify-content-start align-items-start mb-3"
              >
                {field.field_type === "section-title" ? (
                  <h6
                    className="w-100 text-center py-2 my-2"
                    style={{
                      backgroundColor: "rgba(77, 100, 102, 0.1)",
                      color: "rgba(77, 100, 102, 1)",
                      borderRadius: "6px",
                    }}
                  >
                    {field.label}
                  </h6>
                ) : (
                  <>
                    <span className="doc-label d-block">
                      {field.label}
                      {field.required && <span style={{ color: "red" }}> *</span>}
                    </span>

                    {/* Inputs (identical to new response UI but prefilled) */}
                    {field.field_type === "string" && (
                      <input
                        type="text"
                        className="doc-input"
                        value={responseData[field.label] || ""}
                        onChange={e =>
                          handleChange(field.label, e.target.value, field.field_type)
                        }
                      />
                    )}

                    {field.field_type === "text" && (
                      <textarea
                        className="doc-input"
                        rows="3"
                        value={responseData[field.label] || ""}
                        onChange={e =>
                          handleChange(field.label, e.target.value, field.field_type)
                        }
                      ></textarea>
                    )}

                    {field.field_type === "integer" && (
                      <input
                        type="number"
                        className="doc-input"
                        value={responseData[field.label] || ""}
                        onChange={e =>
                          handleChange(field.label, e.target.value, field.field_type)
                        }
                      />
                    )}

                    {field.field_type === "float" && (
                      <input
                        type="number"
                        step="0.01"
                        className="doc-input"
                        value={responseData[field.label] || ""}
                        onChange={e =>
                          handleChange(field.label, e.target.value, field.field_type)
                        }
                      />
                    )}

                    {field.field_type === "boolean" && (
                      <div className="d-flex gap-3 mt-1">
                        {["true", "false"].map(opt => (
                          <label key={opt} className="d-flex align-items-center gap-1">
                            <input
                              type="radio"
                              name={field.label}
                              value={opt}
                              checked={
                                responseData[field.label] === (opt === "true")
                              }
                              onChange={e =>
                                handleChange(field.label, e.target.value, field.field_type)
                              }
                            />
                            {opt === "true" ? "Oui" : "Non"}
                          </label>
                        ))}
                      </div>
                    )}

                    {field.field_type === "date" && (
                      <input
                        type="date"
                        className="doc-input"
                        value={responseData[field.label] || ""}
                        onChange={e =>
                          handleChange(field.label, e.target.value, field.field_type)
                        }
                      />
                    )}

                    {field.field_type === "checkbox" && (
                      <div className="choices-list w-100">
                        {(field.conditions?.options || []).map((option, idx) => {
                          const selected =
                            (responseData[field.label] || []).includes(option);
                          return (
                            <div
                              key={idx}
                              className={`choice-item d-flex justify-content-between align-items-center ${
                                selected ? "selected" : ""
                              }`}
                              onClick={() =>
                                toggleCheckboxOption(field.label, option)
                              }
                            >
                              {option}
                              <FontAwesomeIcon
                                className="select-icon"
                                icon={selected ? faCircleMinus : faCirclePlus}
                              />
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </>
                )}

                {errors[field.label] && (
                  <span className="text-danger small mt-1">
                    {errors[field.label]}
                  </span>
                )}
              </div>
            ))}

            <div className="offcanvas-footer p-3 border-top d-flex justify-content-center bg-white">
              <button type="submit" className="btn-add-doc">
                <FontAwesomeIcon icon={faCheck} className="me-2" />
                Valider & Modifier
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditResponseOffcanvas;
